<div class="col-xl payroll-periods-wrap">
    <div class="d-flex flex-wrap justify-content-between align-items-start mb-3">
        <div>
            <h4 class="mb-0 periods-title">Administrador de periodos</h4>
            <p class="mb-0 periods-subtitle">Administra la apertura y cierre de los periodos de nómina</p>
        </div>
        <div class="d-flex gap-2">
            <button type="button" class="btn periods-export-btn" (click)="exportar()">
                <img src="assets/img/icons/icon-download.svg" alt="">&nbsp;Exportar
            </button>
            <button type="button" class="btn btn-primary periods-new-btn" *ngIf="canDo('Crear')" (click)="nuevoPeriodo()">
                <img src="assets/img/icons/icon-plus.svg" alt="">&nbsp;Nuevo periodo
            </button>
        </div>
    </div>

    <div class="row g-3 mb-4 payroll-kpi-row">
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#ccf0ff;"><img src="assets/img/icons/payroll-kpi-file-text.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Total periodos</p>
                    <p class="payroll-kpi-value">{{stats.total_periods}}</p>
                    <p class="payroll-kpi-sublabel">En el año</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#e3fbe8;"><img src="assets/img/icons/payroll-kpi-play-circle.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Abiertos</p>
                    <p class="payroll-kpi-value">{{stats.open}}</p>
                    <p class="payroll-kpi-sublabel">Periodos activos</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#f1f1f1;"><img src="assets/img/icons/imss-lock.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Cerrados</p>
                    <p class="payroll-kpi-value">{{stats.closed}}</p>
                    <p class="payroll-kpi-sublabel">Periodos cerrados</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#ffccce;"><img src="assets/img/icons/payroll-kpi-alert-circle.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">CFDI's no generados</p>
                    <p class="payroll-kpi-value">{{stats.cfdi_not_generated}}</p>
                    <p class="payroll-kpi-sublabel">Pendientes de timbrar</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#fef3d4;"><img src="assets/img/icons/payroll-kpi-check-circle.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">CFDI's en timbrado</p>
                    <p class="payroll-kpi-value">{{stats.cfdi_in_stamping}}</p>
                    <p class="payroll-kpi-sublabel">En proceso</p>
                </div>
            </div>
        </div>
    </div>

    <div class="card mb-4">
        <div class="card-body">
            <div class="d-flex flex-wrap align-items-end gap-3 mb-3 periods-filters-row">
                <div class="receipts-filter-group">
                    <label class="receipts-filter-label">Año</label>
                    <div class="receipts-filter-input">
                        <select [(ngModel)]="filterYear" (ngModelChange)="onFiltersChanged()">
                            <option *ngFor="let y of yearOptions" [value]="y">{{y}}</option>
                        </select>
                    </div>
                </div>
                <div class="receipts-filter-group">
                    <label class="receipts-filter-label">Estado</label>
                    <div class="receipts-filter-input">
                        <select [(ngModel)]="filterStatus" (ngModelChange)="onFiltersChanged()">
                            <option *ngFor="let opt of statusOptions" [value]="opt.value">{{opt.label}}</option>
                        </select>
                    </div>
                </div>
                <div class="receipts-filter-group">
                    <label class="receipts-filter-label">Periodicidad</label>
                    <div class="receipts-filter-input">
                        <select [(ngModel)]="filterPeriodicity" (ngModelChange)="onFiltersChanged()">
                            <option value="">Todos</option>
                            <option *ngFor="let opt of periodicityOptions" [value]="opt">{{opt}}</option>
                        </select>
                    </div>
                </div>
                <div class="receipts-filter-group">
                    <label class="receipts-filter-label">Tipo de nómina</label>
                    <div class="receipts-filter-input">
                        <select [(ngModel)]="filterPayrollType" (ngModelChange)="onFiltersChanged()">
                            <option value="">Todos</option>
                            <option *ngFor="let opt of payrollTypeOptions" [value]="opt">{{opt}}</option>
                        </select>
                    </div>
                </div>
                <div class="receipts-filter-group">
                    <label class="receipts-filter-label">Tipo de cálculo</label>
                    <div class="receipts-filter-input">
                        <select [(ngModel)]="filterCalculationType" (ngModelChange)="onFiltersChanged()">
                            <option value="">Todos</option>
                            <option *ngFor="let opt of calculationTypeOptions" [value]="opt">{{opt}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="periods-grid ag-theme-alpine" style="height: 50vh; width: 100%;">
                <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-alpine" [columnDefs]="columnDefs"
                    [defaultColDef]="defaultColDef" [rowData]="rowData" [animateRows]="true"
                    [overlayNoRowsTemplate]="noRowsTemplate" (gridReady)="onGridReady($event)"
                    (cellClicked)="onCellClicked($event)">
                </ag-grid-angular>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <div class="text-muted small">Total: {{totalRows}}</div>
            <div class="d-flex align-items-center">
                <label class="me-2 mb-0">Filas por página:</label>
                <select class="form-select form-select-sm me-2" style="width: auto;"
                    (change)="onPageSizeChanged($any($event.target).value)">
                    <option *ngFor="let s of pageSizeOptions" [value]="s" [selected]="s === pageSize">{{s}}</option>
                </select>
                <button class="btn btn-outline-secondary btn-sm me-2 btn-page" (click)="prevPage()"
                    [disabled]="currentPage <= 1">
                    <i class="ti ti-chevron-left"></i>
                </button>
                <span class="me-2">Página {{currentPage}} de {{lastPage}}</span>
                <button class="btn btn-outline-secondary btn-sm btn-page" (click)="nextPage()"
                    [disabled]="currentPage >= lastPage">
                    <i class="ti ti-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
